var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowToIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_86_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1846 33.379C39.599 30.2918 42.0026 27.7645 45.015 26.1971C48.0274 24.6297 51.4765 24.1118 54.8164 24.7253C57.1041 25.0764 59.2775 25.959 61.1623 27.3021C63.0471 28.6452 64.5908 30.4114 65.6696 32.459C66.4463 34.0972 66.8677 35.8811 66.906 37.6937C66.9443 39.5062 66.5986 41.3064 65.8917 42.9759C65.1848 44.6454 64.1327 46.1464 62.8044 47.3803C61.4762 48.6143 59.9019 49.5532 58.185 50.1355C56.4347 50.8002 54.9202 51.9679 53.8322 53.4916C52.7442 55.0153 52.1313 56.8269 52.0708 58.6982V62.2344",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9502 74.5107H51.9885",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5208 94.0417C64.5937 94.0417 76.1721 89.2457 84.7089 80.7089C93.2457 72.1721 98.0417 60.5937 98.0417 48.5208C98.0417 36.448 93.2457 24.8696 84.7089 16.3327C76.1721 7.79593 64.5937 3 52.5208 3C40.448 3 28.8696 7.79593 20.3327 16.3327C11.7959 24.8696 7 36.448 7 48.5208C7 60.5937 11.7959 72.1721 20.3327 80.7089C28.8696 89.2457 40.448 94.0417 52.5208 94.0417Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_86_21",
    x: 0.5,
    y: 0.5,
    width: 104.042,
    height: 104.042,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_21"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_21",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToIcon);
export default __webpack_public_path__ + "static/media/how-to-icon.cd74d83cea20cab88ac13da152a9f1e6.svg";
export { ForwardRef as ReactComponent };